const getTarget = (el) => {
  let target;
  if (typeof el === 'string') {
    target = document.querySelector(el);
  } else if (el instanceof HTMLElement) {
    target = el;
  }
  if (!target) {
    throw new Error('target not found');
  }

  return target;
};

/**
 * Gets element height with margin included.
 * @param {String} selector
 */
export const getElementHeight = (selector) => {
  const rootElement = getTarget(selector);
  const marginBottom = parseInt(window.getComputedStyle(rootElement).getPropertyValue('margin-bottom'));
  const marginTop = parseInt(window.getComputedStyle(rootElement).getPropertyValue('margin-top'));
  const rootElementHeight = rootElement.getBoundingClientRect().height;
  return marginBottom + marginTop + rootElementHeight;
};

const scrollBehavior = !window.matchMedia(`(prefers-reduced-motion: reduce)`).matches ? 'smooth' : 'instant';

const scrollToElement = (element, offset = 100) => {
  const target = getTarget(element);
  const scrollToValue = target.getBoundingClientRect().top + window.scrollY - offset;

  window.scrollTo({
    top: scrollToValue,
    behavior: scrollBehavior,
  });
  const isNaturallyFocusable =
    target.tabIndex >= 0 || ['A', 'BUTTON', 'INPUT', 'SELECT', 'TEXTAREA'].includes(target.tagName);

  if (!isNaturallyFocusable) {
    target.setAttribute('tabindex', '-1');
    target.focus({preventScroll: true});
    setTimeout(() => target.removeAttribute('tabindex'), 100);
  } else {
    target.focus({preventScroll: true});
  }
};

const delayedScrollToElement = (element, offset = 100, delay = 300) => {
  setTimeout(() => {
    scrollToElement(element, offset);
  }, delay);
};

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: scrollBehavior,
  });
};

export {scrollToElement, delayedScrollToElement, scrollToTop};
